/**
 * Resolve Shopify product handles to WOM API handles.
 * Super-saver / flash-sale / pack variants often use a different slug than the
 * base product that owns reviews in overall_company + reviews APIs.
 */
(function () {
  'use strict';

  var COMPANY_CACHE_KEY = 'wom_overall_company_conscious_chemist_v1';

  var HANDLE_SUFFIXES = [
    '-super-saver-sale',
    '-supersaver-sale',
    '-flash-sale',
    '-hp-offers',
    '-special-deal',
    '-hp',
  ];

  function normalizeHandle(handle) {
    return String(handle || '').toLowerCase().trim();
  }

  function hasReviewData(row) {
    if (!row || typeof row !== 'object') return false;
    if (Number(row.overall_rating) > 0 || Number(row.total_reviews) > 0) return true;
    return !!(row.external_ratings && typeof row.external_ratings === 'object' && Object.keys(row.external_ratings).length);
  }

  function readCompanyCache() {
    try {
      var raw = sessionStorage.getItem(COMPANY_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.data || typeof parsed.data !== 'object') return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function getHandleVariants(handle) {
    handle = normalizeHandle(handle);
    if (!handle) return [];

    var variants = [];
    var seen = {};

    function add(candidate) {
      candidate = normalizeHandle(candidate);
      if (!candidate || seen[candidate]) return;
      seen[candidate] = true;
      variants.push(candidate);

      var underscore = candidate.replace(/-/g, '_');
      var hyphen = candidate.replace(/_/g, '-');
      var ageing = candidate.replace(/anti-ageing/g, 'anti-aging');
      var aging = candidate.replace(/anti-aging/g, 'anti-ageing');

      add(underscore);
      add(hyphen);
      if (ageing !== candidate) add(ageing);
      if (aging !== candidate) add(aging);
    }

    add(handle);

    var current = handle;
    HANDLE_SUFFIXES.forEach(function (suffix) {
      if (current.endsWith(suffix)) {
        current = current.slice(0, -suffix.length);
        add(current);
      }
    });

    if (/[-_]\d+$/.test(current)) {
      add(current.replace(/[-_]\d+$/, ''));
    }

    var packMatch = handle.match(/^(.*?)(?:-pack-of-(?:two|2|three|3|\d+).*)$/i);
    if (packMatch && packMatch[1]) {
      add(packMatch[1]);
    }

    var miniMatch = handle.match(/^(.*?)(?:-mini(?:-pack-of-two|-pack-of-2)?.*)$/i);
    if (miniMatch && miniMatch[1]) {
      add(miniMatch[1]);
    }

    return variants;
  }

  function lookupInCompanyData(data, handle) {
    if (!data || !handle) return null;
    var variants = getHandleVariants(handle);
    for (var i = 0; i < variants.length; i++) {
      var row = data[variants[i]];
      if (hasReviewData(row)) {
        return { handle: variants[i], data: row };
      }
    }
    return null;
  }

  function stripKnownSuffixes(handle) {
    var current = normalizeHandle(handle);
    if (!current) return current;

    HANDLE_SUFFIXES.forEach(function (suffix) {
      if (current.endsWith(suffix)) {
        current = current.slice(0, -suffix.length);
      }
    });

    if (/[-_]\d+$/.test(current)) {
      current = current.replace(/[-_]\d+$/, '');
    }

    var packMatch = current.match(/^(.*?)(?:-pack-of-(?:two|2|three|3|\d+).*)$/i);
    if (packMatch && packMatch[1]) {
      current = packMatch[1];
    }

    var miniMatch = current.match(/^(.*?)(?:-mini(?:-pack-of-two|-pack-of-2)?.*)$/i);
    if (miniMatch && miniMatch[1]) {
      current = miniMatch[1];
    }

    return current;
  }

  function resolveReviewsHandle(handle, companyData) {
    handle = normalizeHandle(handle);
    if (!handle) return null;

    var data = companyData || readCompanyCache();
    var match = lookupInCompanyData(data, handle);
    if (match) return match.handle;

    var stripped = stripKnownSuffixes(handle);
    if (stripped && stripped !== handle) {
      return stripped;
    }

    return handle;
  }

  window.WOMHandleResolver = {
    getHandleVariants: getHandleVariants,
    lookupInCompanyData: lookupInCompanyData,
    resolveReviewsHandle: resolveReviewsHandle,
    readCompanyCache: readCompanyCache,
    hasReviewData: hasReviewData,
  };
})();
